import React from "react";
import PropTypes from 'prop-types';

// wrap a component in a delayed onChange; the component must use onChange for messaging
// onchange is (field, value)
export default (WrappedComponent) => {
	const propTypes = {
		timeoutLength: PropTypes.number,
	};

	const defaultProps = {
		timeoutLength: 1000,
	};

	class DelayedInput extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				currentValue: this.props.value,
			};
			this.timeout = undefined;
			this.lastSentValue = this.props.value;

			this.onChange = this.onChange.bind(this);
		}

		componentDidUpdate() {
			// if the owner changes the value then keep that value; unless a timeout is in progress meaning there are changes yet to send to the owner
			if (this.props.value !== this.state.currentValue && !this.timeout) {
				this.lastSentValue = this.props.value;
				this.setState({currentValue: this.props.value});
			}
		}

		// delay sending the change to the parent
		onChange(field, value) {
			if (this.timeout) {
				clearTimeout(this.timeout);
				this.timeout = undefined;
			}

			this.setState({currentValue: value});

			// only send new value if the value has changed since the last time it was sent
			this.timeout = setTimeout(() => {
				this.timeout = undefined;
				if (this.state.currentValue !== this.lastSentValue) {
					this.lastSentValue = this.state.currentValue;
					this.props.onChange(field, this.state.currentValue);
				}
			}, this.props.timeoutLength);
		}

		render() {
			// use current value in the component, but don't send that value yet to the parent
			return <WrappedComponent {...Object.assign({}, this.props, {onChange: this.onChange, value: this.state.currentValue})}/>;
		}
	}

	DelayedInput.propTypes = propTypes;

	DelayedInput.defaultProps = defaultProps;

	return DelayedInput;
};
